module.exports = __webpack_public_path__ + "img/rencai.e816c07c.png";